import { Fragment } from "react"
import { cn } from "cn"

import { EMOJI_REGEX, SINGLE_EMOJI_REGEX } from "@/lib/emoji-utils"

/**
 * Shimmering text that keeps color emoji intact. The `shimmer` utility hides
 * the glyphs' own paint and clips its gradient to their outlines, which turns
 * color emoji into solid silhouettes — the utility exempts `font-emoji` spans,
 * so emoji runs are wrapped in them here.
 */
export function ShimmerText({
  text,
  className,
}: {
  text: string
  className?: string
}) {
  return (
    <div className={cn("shimmer", className)}>
      {text.split(EMOJI_REGEX).map((part, i) =>
        SINGLE_EMOJI_REGEX.test(part) ? (
          <span key={i} className="font-emoji">
            {part}
          </span>
        ) : (
          <Fragment key={i}>{part}</Fragment>
        )
      )}
    </div>
  )
}
